// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ornamentValidation({ ornament }) {
    return { status: "pass" };
}
//# sourceMappingURL=Validation.js.map